





















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import showDiv from '@ivy/fts/showDiv'
import { watch } from 'fs'
@Component({
  filters: {
    couponType: type => {
      return {
        all: '通用券',
        designation: '商品券',
      }[type]
    },
    thresholdPrice: num => {
      const number = +num
      return number ? `满${number.toFixed()}可用` : '无门槛'
    },
    numberFixed: num => {
      const number = +num
      return number ? `${number.toFixed()}` : '0'
    },
    toSecond: time => {
      if (!time) return time
      return time.replace(/-/g, '.').slice(0, 16)
    },
  },
})
export default class disCountList extends Vue {
  @Prop() discounts
  @Prop() active_coupon
  @Prop() dis_coupon
  @Prop() coupon_id

  coupons: any = []
  unCoupons: any = []
  vipCoupons: any[] = []
  //   choooseCoupon = null
  curType: string = 'all' // 当前选中的优惠券类型

  chooseCoupon() {
    this.$emit('chooseCoupon', this.coupon_id)
  }
  get couponTimeRange() {
    return coupon => {
      let start = (coupon.use_start_time || '').replace(/-/g, '.').slice(0, 16)
      let end = (coupon.use_end_time || '').replace(/-/g, '.').slice(0, 16)
      if (start && end) {
        return start + ' 至 ' + end
      }
      if (start) {
        return start
      }
      if (end) {
        return end
      }
      return ''
    }
  }

  get isSameCoupon() {
    return coupon => {
      return this.coupon_id === coupon.id
    }
  }

  async created() {
    await env.init()
  }

  tabIndexChange(type) {
    this.curType = type
  }

  onCheck(coupon) {
    if (!coupon) return
    if (!this.coupon_id || this.coupon_id != coupon.id) {
      this.coupon_id = coupon.id
    } else if (this.coupon_id && this.coupon_id == coupon.id) {
      this.coupon_id = null
    }
    this.chooseCoupon()
  }
}
